import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.community.item');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import ClassicEditor from "src/libs/portal/season/ckeditor/ckeditor";
import { Router } from '@angular/router'
import { marked } from 'marked';

@Component({
    selector: 'wiz-portal-gsdcadmin-community-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.community.item/view.scss */
.leader-notice {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.75rem;
  margin: 0 0 1rem;
  padding: 0.875rem 1rem;
  border: 1px solid var(--gsdc-border, #d5e1ec);
  border-radius: 0.75rem;
  background: var(--gsdc-card, #f4f8fc);
  color: var(--gsdc-text, #24384c);
  overflow-wrap: anywhere;
}
.leader-notice.is-warning {
  border-color: #c99132;
}
.leader-notice.is-error {
  border-color: #c45454;
}
.leader-notice a {
  text-decoration: underline;
  font-weight: 600;
}

input:disabled {
  cursor: wait;
  opacity: 0.6;
}`],
})
export class PortalGsdcadminCommunityItemComponent implements OnInit, OnDestroy {
    @ViewChild('editor')
    public editorElement: ElementRef;
    public editor: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @Input() community_id: any;
    public community: any = {};
    public groupTotal: any = 0;
    public groups: any = [];
    public users: any = [];

    public pagination: any = {
        page: 1,
        start: 1,
        end: 1
    }
    public searchTerm = "";
    public total = 0;

    public async ngOnInit() {
        await this.service.init();
        await this.communityLoad();
        await this.groupLoad();
        await this.userLoad();
        await this.buildEditor();
    }

    public async communityLoad() {
        const { code, data } = await wiz.call("communityLoad", { id: this.community_id });
        if (code != 200) return await this.service.alert.error("Error!");
        this.community = data.community;
        this.groupTotal = data.groupTotal;
        await this.service.render();
    }

    public async groupLoad() {
        const { code, data } = await wiz.call("groupLoad", { id:this.community_id });
        if (code != 200) return await this.service.alert.error("Error!");
        this.groups = data;
        await this.service.render();
    }

    public async userLoad() {
        const { code, data } = await wiz.call("userLoad", { text: this.searchTerm, page: this.pagination.page, communityID: this.community_id });
        if (code != 200) return await this.service.alert.error("Error!");
        this.users = data.users;
        this.pagination.start = Math.floor((this.pagination.page - 1) / 10) * 10 + 1;
        this.pagination.end = data.lastpage;
        this.total = data.total;
        await this.service.render();
    }

    private async pageLoad(p: number) {
        this.pagination.page = p;
        await this.userLoad();
    }

    public async buildEditor() {
        if (this.community.description == null) this.community.description = "";
        let editor = this.editor = await ClassicEditor.create(this.editorElement.nativeElement, {
            toolbar: {
                items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                    '|', 'bold', 'italic', 'strikethrough', 'underline',
                    '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
                    '|', 'link', 'uploadImage', 'insertTable', 'blockQuote', 'codeBlock', 'horizontalLine'
                ],
                shouldNotGroupWhenFull: true
            },
            codeBlock: {
                languages: [
                    { language: 'plaintext', label: '평문' },
                    { language: 'c', label: 'C' },
                    { language: 'cpp', label: 'C++' },
                    { language: 'cs', label: 'C#' },
                    { language: 'css', label: 'CSS' },
                    { language: 'diff', label: 'Diff' },
                    { language: 'html', label: 'HTML' },
                    { language: 'java', label: 'Java' },
                    { language: 'javascript', label: 'JavaScript' },
                    { language: 'markdown', label: 'Markdown' }, // 여기서 Markdown 추가
                    { language: 'php', label: 'PHP' },
                    { language: 'python', label: 'Python' },
                    { language: 'ruby', label: 'Ruby' },
                    { language: 'typescript', label: 'TypeScript' },
                    { language: 'xml', label: 'XML' }
                ]
            },
            link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'https://',
            },
            removePlugins: ["MediaEmbedToolbar"],
            table: ClassicEditor.defaultConfig.table,
            simpleUpload: {
                uploadUrl: '/file/upload'
            }
        });
        this.editor.data.set(this.community.description);
    }

    public async ngOnDestroy() {
        this.community.description = this.editor.getData();
    }

    public async update() {
        if (this.tab == 'text') this.changeTab('editor')
        this.community.description = this.editor.getData();
        const { code } = await wiz.call("update", { id: this.community_id, description: this.community.description });
        if (code != 200) return await this.service.alert.error("오류가 발생했습니다.");
        let res = await this.service.alert.success("저장되었습니다.");
        if (res && !('id' in this.community)) await this.router.navigate(['/admin/community']);
        await this.service.render();
    }

    public tab: 'editor' | 'text' = 'editor';

    public async changeTab(tab: 'editor' | 'text') {
        if (!this.editor) {
            this.tab = tab;
            await this.service.render();
            return;
        }

        if (this.tab === 'editor' && tab === 'text') this.community.description = this.editor.getData();
        if (this.tab === 'text' && tab === 'editor') this.editor.setData(this.community.description || '');

        this.tab = tab;
        await this.service.render();
    }

    public leaderChanging = false;
    public leaderNotice = '';
    public leaderNoticeKind = '';
    public leaderNoticeUser = '';

    public async changeLeader(user: any, event: Event) {
        const checkbox = event.target as HTMLInputElement;
        const original = user.representative === 'Y' ? 'Y' : 'N';
        const next = checkbox.checked ? 'Y' : 'N';
        checkbox.checked = original === 'Y';
        if (this.leaderChanging || next === original) return;

        this.leaderChanging = true;
        this.leaderNotice = '';
        this.leaderNoticeKind = '';
        this.leaderNoticeUser = user.full_name || user.account_name || '';
        try {
            await this.service.render();
            const confirmed = await this.service.alert.show({
                title: next === 'Y' ? '연구커뮤니티 대표 지정' : '연구커뮤니티 대표 해제',
                message: next === 'Y' ? '해당 사용자를 연구커뮤니티 대표로 지정하시겠습니까?' : '해당 사용자의 연구커뮤니티 대표 지정을 해제하시겠습니까?',
                action: next === 'Y' ? '지정' : '해제', cancel: '취소',
                actionBtn: next === 'Y' ? 'success' : 'error', status: next === 'Y' ? 'success' : 'error'
            });
            if (confirmed !== true) return;

            let response: any;
            try {
                response = await wiz.call('changeLeader', {
                    user: JSON.stringify({id: user.id, member_id: user.member_id, representative: next}),
                    community: JSON.stringify({id: this.community.id || this.community_id})
                });
            } catch (_) {
                this.leaderNotice = '처리 결과를 확인하지 못했습니다. 새로고침해 대표 상태를 확인해주세요.';
                this.leaderNoticeKind = 'error';
            }

            if (response) {
                const data = response.data;
                if (response.code !== 200 || !(data === true || (data && typeof data === 'object'))) {
                    this.leaderNotice = (typeof data === 'string' ? data : data?.message) || '연구커뮤니티 대표 지정/해제에 실패했습니다.';
                    this.leaderNoticeKind = 'error';
                } else {
                    user.representative = next;
                    checkbox.checked = next === 'Y';
                    this.leaderNotice = data?.message || '연구커뮤니티 대표 지정/해제를 완료했습니다.';
                    this.leaderNoticeKind = data?.notification_status && !['sent', 'no_recipients', 'unchanged', 'not_required'].includes(data.notification_status) ? 'warning' : 'success';
                }
            } else if (!this.leaderNotice) {
                this.leaderNotice = '처리 결과를 확인하지 못했습니다. 새로고침해 대표 상태를 확인해주세요.';
                this.leaderNoticeKind = 'error';
            }
        } finally {
            this.leaderChanging = false;
            await this.service.render();
        }
        if (this.leaderNoticeKind === 'error') await this.service.alert.error(this.leaderNotice);
        else if (this.leaderNoticeKind === 'warning') await this.service.alert.warning(this.leaderNotice);
        else await this.service.alert.success(this.leaderNotice);
    }
}

export default PortalGsdcadminCommunityItemComponent;